module.exports = __webpack_public_path__ + "media/img/pages/companies/lgt-7e0bc293bdcdc56b7e4758335f5dc617.png";